// extracted by css-extract-rspack-plugin
export default {"header":"L72qoLO7YUUupQ9d"};